import React from 'react';

interface Props {
  onClick?: () => void;
  label: React.ReactNode;
}

/** Saved-filter pill — clickable tag that applies a stored filter. Shared by the legacy and v2 filter bars. */
export const FilterTag: React.FC<Props> = ({ onClick, label }) => (
  <div
    onClick={onClick}
    className="inline-flex items-center gap-1 rounded px-2 py-1 text-sm leading-4 bg-complementary-brandLight text-content-brand cursor-pointer transition-colors hover:bg-content-brandMedium"
  >
    {label}
  </div>
);